const urls = require('../constants/urls');
const { getBlogURL, getFinancialReportURL } = require('./url-utils');

exports.getShareMenu = (text) => {
  const baseUrl = encodeURIComponent('https://info.ecosia.org?utm_source=stc');
  return [{
    label: 'Facebook',
    id: 'facebook',
    url: `https://www.facebook.com/sharer/sharer.php?u=${baseUrl}&t=${text}`,
  }, {
    label: 'Twitter',
    id: 'twitter',
    url: `https://www.twitter.com/share?url=${baseUrl}&text=${text}`,
  }, {
    label: 'Pinterest',
    id: 'pinterest',
    url: `http://pinterest.com/pin/create/link/?url=${baseUrl}`,
  }];
};

exports.getFooterMenu = (locale, settingsLink = false) => {
  const menu = [{
    url: `${process.env.infoUrl}/privacy`,
    key: 'privacy',
  }, {
    url: `${process.env.infoUrl}/imprint`,
    key: 'imprint',
  }, {
    url: urls.HELP,
    key: 'help', // @TODO change to help
  }];
  if (settingsLink) {
    menu.push({
      url: `${process.env.indexpageUrl}settings`,
      key: 'settings',
    });
  }
  return menu;
};

exports.getFeedbackLink = () => urls.HELPSCOUT_CONTACT_US;

exports.getFooterWhatWeDo = (locale) => [
  {
    url: `${process.env.infoUrl}/what`,
    key: 'how',
  },
  {
    url: getFinancialReportURL(locale),
    key: 'financial',
  },
  {
    url: urls.HELPSCOUT_ADVERTISE_ON_ECOSIA,
    key: 'advertising',
  },
  {
    url: urls.SHOP,
    key: 'shop',
  },
  {
    url: urls.GIFTING_TREES,
    key: 'gift',
  },
];

exports.getFooterAbout = (locale) => [
  {
    url: urls.JOBS,
    key: 'careers',
  },
  {
    url: `${process.env.infoUrl}/press`,
    key: 'press',
  },
  {
    url: getBlogURL(locale),
    key: 'blog2',
  },
  {
    url: urls.FAQ,
    key: 'faq',
  },
];

exports.getFooterLegal = () => [
  {
    url: `${process.env.infoUrl}/privacy`,
    key: 'privacypolicy',
  },
  {
    url: urls.TERMS_OF_SERVICE,
    key: 'terms',
  },
  {
    url: `${process.env.infoUrl}/imprint`,
    key: 'imprint',
  },
];

exports.getSocialMenu = (withBlog = false, locale) => {
  const menu = [
    {
      name: 'Instagram',
      label: 'instagram',
      url: urls.INSTAGRAM,
    }, {
      name: 'YouTube',
      label: 'youtube',
      url: urls.YOUTUBE,
    },
    {
      name: 'Twitter',
      label: 'twitter',
      url: urls.TWITTER,
    },
    {
      name: 'LinkedIn',
      label: 'linkedin',
      url: urls.LINKEDIN,
    },
    {
      name: 'TikTok',
      label: 'tiktok',
      url: urls.TIKTOK,
    },
    {
      name: 'Facebook',
      label: 'facebook',
      url: urls.FACEBOOK,
    },
  ];

  if (withBlog === true) {
    return menu.concat({
      name: 'Blog',
      label: 'blog',
      url: getBlogURL(locale),
    });
  }

  return menu;
};

exports.getMainMenu = (locale, settingsUrl) => [[
  {
    url: `${process.env.infoUrl}/what`,
    key: 'how',
  }, {
    url: `${process.env.infoUrl}/privacy`,
    key: 'privacy',
  },
  {
    url: urls.GIFTING_TREES,
    key: 'giftingtrees',
  },
  {
    url: urls.SHOP,
    key: 'shop',
  }, {
    url: getBlogURL(locale),
    key: 'blog',
  }, {
    url: urls.JOBS,
    key: 'careers',
  }, {
    url: urls.FAQ,
    key: 'faq',
  },
], [
  {
    url: settingsUrl || '/settings',
    key: 'settings',
  },
]];
